module.exports = __webpack_public_path__ + "img/email.521e5cd6.png";